import { register } from "async-ops";
import { callMvcApi  } from "../../../../call-web-api";
export const MARK_NOTIFICATION_AS_READ = 'MARK_NOTIFICATION_AS_READ';


export const service = async (notificationId) => {
  const options: object = {
    url:  '/Api/Utility/MarkNotificationAsRead/' + notificationId,
    method: "GET",
  }
  const response = await callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(MARK_NOTIFICATION_AS_READ, service, mock);
